export type ColorSirena = 'azul' | 'verde' | 'amarilla' | 'roja';

export interface EstadoSirenaInput {
  online?: boolean;
  sonidoEncendido?: boolean;
  luzEncendida?: boolean;
  actualizando?: boolean;
}

/** Texto de estado mostrado en la isla. */
export function estadoSirena(s: EstadoSirenaInput): string {
  if (s.online) {
    if (s.sonidoEncendido && s.luzEncendida) return 'Online - Sirena y Reflector Encendidos';
    if (s.sonidoEncendido) return 'Online - Sirena Encendida';
    if (s.luzEncendida) return 'Online - Reflector Encendido';
    return 'Online - Apagada';
  }
  if (s.actualizando) return 'Offline - Actualizando Firmware';
  return 'Offline';
}

/** Activa = online con sonido o luz encendidos (lo que "late" en el mapa). */
export function sirenaActiva(s: EstadoSirenaInput): boolean {
  return !!s.online && (!!s.sonidoEncendido || !!s.luzEncendida);
}

/** Clave de color del marcador. `verActualizaciones` viene de la config del cliente del usuario. */
export function colorSirena(s: EstadoSirenaInput, verActualizaciones = false): ColorSirena {
  if (s.online) return s.sonidoEncendido || s.luzEncendida ? 'azul' : 'verde';
  if (s.actualizando) return verActualizaciones ? 'amarilla' : 'verde';
  return 'roja';
}
